export const NONE = 'none';
export const GREEN = 'green';
export const YELLOW = 'yellow';
export const RED = 'red';

export const scores = [NONE, GREEN, YELLOW, RED];
